// extracted by mini-css-extract-plugin
module.exports = {"multipleSingleDigits":"multiple-single-digits_1FKdO"};